import { filterOptions } from '@/utils/query-base'

const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
}

export default {
  'customerCode': {
    title: '客户编码',
    type: 'dialog',
    equation: all,
    width: 170,
    dialog: {
      component: 'ClientSelect',
      title: '客户编码'
    }
  },
  'customerName': {
    title: '客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'type': {
    title: '类型',
    type: 'select',
    equation: all,
    width: 150,
    dictionary: 'transferType', // 设置一个字典标识符
    clear: false, // 不显示空白选项
    dictionaryVal: [
      { name: '转出', value: 'TRANSFER' },
      { name: '转入', value: 'RECEIVE' }
    ],
    formatter: ({ cellValue }) => {
      if (cellValue === 'TRANSFER') {
        return '转出'
      } else if (cellValue === 'RECEIVE') {
        return '转入'
      }
      return cellValue
    }
  },
}



// WEBPACK FOOTER //
// ./src/views/apply-for-manage/base-setting/config/transferAnyCustomerSetting.js